import { MediaTypePostEditorState } from '../../../models/post-editor';
import { MediaType } from '../../../models/graphql';

export const mediaContainsVideo = (media: MediaTypePostEditorState[]): boolean =>
  !!media.filter(m => m.type === MediaType.VIDEO)?.length;
